import { PlayerRef } from '@remotion/player';
import createStore from '@/stores/store';

export const remotionPlayerStateStore = createStore({
  currentTime: 0
});

export function setCurrentTime(currentTime: number, fps: number, remotionPlayerRef: PlayerRef) {
  remotionPlayerRef.seekTo(Math.floor(currentTime * fps));
  remotionPlayerStateStore.set(state => ({
    ...state,
    currentTime
  }));
}

export function setCurrentTimeWithoutSeeking(currentTime: number) {
  remotionPlayerStateStore.set(state => ({
    ...state,
    currentTime
  }));
}
